<ng-container *ngIf="!!analyticsData">

  <p *ngIf="analyticsData.impressions === 0" class="no-vis">No Impressions Captured</p>

  <div *ngIf="analyticsData.impressions > 0" class="row">
    <div [ngClass]="{
      'col-12 col-lg-7': analyticsData.isContactForm,
      'col-12': !analyticsData.isContactForm
    }">
      <apx-chart *ngIf="analyticsData.impressionLabels.length > 2"
        [series]="analyticsData.impressionSeries"
        [title]="analyticsData.impressionTitle"
        [labels]="analyticsData.impressionLabels"
        [chart]="pieChart.chart"
        [responsive]="pieChart.responsive"
        [legend]="pieChart.legend"
        [dataLabels]="pieChart.dataLabels"
        [colors]="pieChart.colors"
        [plotOptions]="pieChart.plotOptions"
        [tooltip]="pieChart.tooltip"
        [states]="pieChart.states"
        triggers=""
      ></apx-chart>

      <apx-chart *ngIf="analyticsData.impressionLabels.length < 2"
        [series]="analyticsData.impressionSeries"
        [title]="analyticsData.impressionTitle"
        [chart]="impressionBarChart.chart"
        [dataLabels]="impressionBarChart.dataLabels"
        [plotOptions]="impressionBarChart.plotOptions"
        [responsive]="impressionBarChart.responsive"
        [xaxis]="impressionBarChart.xaxis"
        [yaxis]="impressionBarChart.yaxis"
        [fill]="impressionBarChart.fill"
        [tooltip]="impressionBarChart.tooltip"
        [colors]="impressionBarChart.colors"
        [states]="impressionBarChart.states"
        triggers=""
      ></apx-chart>
    </div>

    <div class="col-12" [ngClass]="{
      'col-lg-5': analyticsData.isContactForm,
      'col-xl-4': analyticsData.isContactForm,
      'offset-xl-1': analyticsData.isContactForm,
      'mt-4': analyticsData.isContactForm,
      'mt-lg-0': analyticsData.isContactForm,
    }">
      <div class="row">
        <div class="col-12 col-sm-6" [ngClass]="{
          'col-lg-12': analyticsData.isContactForm,
          'col-xl-3': !analyticsData.isContactForm
        }">
          <div class="nav-link d-flex p-2 gap-3">
            <div class="avatar-sm flex-shrink-0">
              <div class="avatar-title rounded bg-warning-subtle text-warning fs-2xl">
                <i class="bi bi-binoculars-fill"></i>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="text-reset">
                <span class="counter-value">{{ abbreviateNumber(analyticsData.impressions) }}</span>
              </h5>
              <p class="mb-0">Total Views</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6" [ngClass]="{
          'col-lg-12': analyticsData.isContactForm,
          'col-xl-3': !analyticsData.isContactForm
        }">
          <div class="nav-link d-flex p-2 gap-3">
            <div class="avatar-sm flex-shrink-0">
              <div class="avatar-title rounded bg-warning-subtle text-warning fs-2xl">
                <i class="bi bi-person-bounding-box"></i>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="text-reset">
                <span class="counter-value">{{ abbreviateNumber(analyticsData.reach) }}</span>
              </h5>
              <p class="mb-0">Unique Visitors</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6" [ngClass]="{
          'col-lg-12': analyticsData.isContactForm,
          'col-xl-3': !analyticsData.isContactForm
        }">
          <div class="nav-link d-flex p-2 gap-3">
            <div class="avatar-sm flex-shrink-0">
              <div class="avatar-title rounded bg-warning-subtle text-warning fs-2xl">
                <i class="bi bi-clipboard2-pulse-fill"></i>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="text-reset">
                <span class="counter-value">{{ analyticsData.responseRate.toFixed(2) }}%</span>
              </h5>
              <p class="mb-0">Conversion Rate</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6" [ngClass]="{
          'col-lg-12': analyticsData.isContactForm,
          'col-xl-3': !analyticsData.isContactForm
        }">
          <div class="nav-link d-flex p-2 gap-3">
            <div class="avatar-sm flex-shrink-0">
              <div class="avatar-title rounded bg-warning-subtle text-warning fs-2xl">
                <i class="bi bi-calendar-event-fill"></i>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="text-reset">
                <span class="counter-value">{{ formatDate(analyticsData.mostRecentResponse, 'MM/dd/yyyy', 'en') }}</span>
              </h5>
              <p class="mb-0">Last Response</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="analyticsData.totalDonationCount > 0" class="row border-top pt-4 mt-4">
    <div class="col-12 col-lg-7">
      <apx-chart
        [series]="analyticsData.donationSeries"
        [title]="analyticsData.donationTitle"
        [legend]="analyticsData.donationLegend"
        [chart]="barChart.chart"
        [dataLabels]="barChart.dataLabels"
        [plotOptions]="barChart.plotOptions"
        [responsive]="barChart.responsive"
        [xaxis]="barChart.xaxis"
        [yaxis]="barChart.yaxis"
        [fill]="barChart.fill"
        [tooltip]="barChart.tooltip"
        [colors]="barChart.colors"
        [states]="barChart.states"
        triggers=""
      ></apx-chart>
    </div>
    <div class="col-12 col-lg-4 col-xl-4 offset-xl-1 mt-4">
      <div class="row">
        <div class="col-12 col-sm-6 col-lg-12">
          <div class="nav-link d-flex p-2 gap-3">
            <div class="avatar-sm flex-shrink-0">
              <div class="avatar-title rounded bg-success-subtle text-success fs-2xl">
                <i class="bi bi-cart-fill"></i>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="text-reset">
                <span class="counter-value">
                  {{ analyticsData.totalDonationCount }}
                </span>
              </h5>
              <p class="mb-0">Donations</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-12">
          <div class="nav-link d-flex p-2 gap-3">
            <div class="avatar-sm flex-shrink-0">
              <div class="avatar-title rounded bg-success-subtle text-success fs-2xl">
                <i class="bi bi-cash"></i>
              </div>
            </div>
            <div class="flex-grow-1">
              <h5 class="text-reset">
                <span class="counter-value">
                  {{ analyticsData.averageDonation.toLocaleString('en-US', {style: 'currency', currency: 'USD'}) }}
                </span>
              </h5>
              <p class="mb-0">Average Donation</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
